import { Route } from 'react-router-dom';
import { PublicRoute } from '@/components';
import { lazyPage } from './lazy';

const LoginPage = lazyPage(() => import('@/features/auth/pages/LoginPage'), 'LoginPage');
const RegisterPage = lazyPage(() => import('@/features/auth/pages/RegisterPage'), 'RegisterPage');
const ForgotPasswordPage = lazyPage(
  () => import('@/features/auth/pages/ForgotPasswordPage'),
  'ForgotPasswordPage'
);
const ResetPasswordPage = lazyPage(
  () => import('@/features/auth/pages/ResetPasswordPage'),
  'ResetPasswordPage'
);
const ActivateAccountPage = lazyPage(
  () => import('@/features/auth/pages/ActivateAccountPage'),
  'ActivateAccountPage'
);
const ConfirmEmailChangePage = lazyPage(
  () => import('@/features/auth/pages/ConfirmEmailChangePage'),
  'ConfirmEmailChangePage'
);
const SsoCompletePage = lazyPage(
  () => import('@/features/auth/pages/SsoCompletePage'),
  'SsoCompletePage'
);
const JoinBatchPage = lazyPage(
  () => import('@/features/auth/pages/JoinBatchPage'),
  'JoinBatchPage'
);
const AcceptInvitePage = lazyPage(
  () => import('@/features/auth/pages/AcceptInvitePage'),
  'AcceptInvitePage'
);

export const AuthRoutes = () => (
  <>
    <Route
      path="/login"
      element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      }
    />
    <Route
      path="/register"
      element={
        <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      }
    />
    <Route
      path="/forgot-password"
      element={
        <PublicRoute>
          <ForgotPasswordPage />
        </PublicRoute>
      }
    />
    <Route
      path="/reset-password"
      element={
        <PublicRoute>
          <ResetPasswordPage />
        </PublicRoute>
      }
    />
    {/* Email change confirmation — public, token comes from email link */}
    <Route path="/confirm-email-change" element={<ConfirmEmailChangePage />} />
    {/* Organization invitation — public; the token in the URL is the credential,
        and the invitee has no account to be logged into yet. */}
    <Route path="/invite/:token" element={<AcceptInvitePage />} />
    {/* Back from Google / Microsoft sign-in: the refresh cookie is set, finish in the SPA. */}
    <Route path="/auth/sso/complete" element={<SsoCompletePage />} />
    {/* Batch join link a college shared; works signed in or out. */}
    <Route path="/join/:code" element={<JoinBatchPage />} />
    {/* Account activation holding page */}
    <Route
      path="/activate"
      element={
        <PublicRoute>
          <ActivateAccountPage />
        </PublicRoute>
      }
    />
  </>
);
